export const isGeneratorPage = buzz => buzz?.classification?.section === 'Make Yours';
